import template from './dashboard-card-my-devices.component.html';
import controller from './dashboard-card-my-devices.controller';

const dashboardCardMyDevices = {
  template,
  controller,
};

export default dashboardCardMyDevices;
